import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import {
  ModalBackdrop,
  CloseBtn,
  CloseBtnWpar,
  CategoriesWrap,
  ModalContainer,
  BtnWrap,
} from '../ModalTransaction.styled';
import {
  CategoryBtn,
  CategoryText,
} from 'components/Modal/ModalTransaction/ModalTransaction.styled';
import StyledButton from '../../../Buttons/Buttons.styled';
import { useTranslation } from 'react-i18next';
import {
  BadgePercent,
  Bitcoin,
  Bus,
  Car,
  ChevronDown,
  CircleHelp,
  Dumbbell,
  Gamepad2,
  Gift,
  GraduationCap,
  HandCoins,
  HeartHandshake,
  Home,
  Landmark,
  PawPrint,
  Pill,
  Plane,
  Receipt,
  Shirt,
  ShoppingBasket,
  Sparkles,
  ToyBrick,
  Truck,
  UtensilsCrossed,
  Wifi,
} from 'lucide-react';

const categoryIconMap = {
  'icon-education': GraduationCap,
  'icon-entertainment': Gamepad2,
  'icon-fashion': Shirt,
  'icon-gifts': Gift,
  'icon-groceries': ShoppingBasket,
  'icon-household': Home,
  'icon-Interest': BadgePercent,
  'icon-internet': Wifi,
  'icon-paydayLoans': HandCoins,
  'icon-medical': Pill,
  'icon-pets': PawPrint,
  'icon-rent': Landmark,
  'icon-restaurants': UtensilsCrossed,
  'icon-salary': Landmark,
  'icon-self': Sparkles,
  'icon-shipping': Truck,
  'icon-sport': Dumbbell,
  'icon-toys': ToyBrick,
  'icon-transport': Bus,
  'icon-trips': Plane,
  'icon-utilities': Receipt,
  'icon-charity': HeartHandshake,
  'icon-Car-service': Car,
  'icon-bitcoin': Bitcoin,
  'icon-noCategory': CircleHelp,
};

const modalRoot = document.querySelector('#modal-root');

export const ModalCategories = ({
  onClose,
  setIcon,
  categoriesMore,
  setCategoriesMore,
  setCategories,
  setSelectedCategory,
}) => {
  const [clickedCategoryId, setClickedCategoryId] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    document.body.style.overflow = 'hidden';

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'unset';
    };
  });

  const handleKeyDown = evt => {
    if (evt.code === 'Escape') {
      onClose();
    }
  };

  const handleBackdropClick = evt => {
    if (evt.target === evt.currentTarget) {
      onClose();
    }
  };

  const handleClick = (categoryName, id) => {
    const updatedCategories = [...categoriesMore];
    const clickedCategoryIndex = updatedCategories.findIndex(
      category => category.categoryName === categoryName
    );
    if (clickedCategoryIndex !== -1) {
      const clickedCategory = updatedCategories.splice(
        clickedCategoryIndex,
        1
      )[0];

      updatedCategories.unshift(clickedCategory);
      setIcon(clickedCategory.id);
      setClickedCategoryId(clickedCategory.id);
    } else {
      alert('hi, you have problem'); // нужна кнпка для перезагрузки или переписать код на асинхронный
    }
    setCategoriesMore(updatedCategories);
    setSelectedCategory(id);
  };

  const handleSaveClick = () => {
    if (clickedCategoryId !== null) {
      setIcon(clickedCategoryId);
      setCategories(categoriesMore);
      onClose();
    } else {
      alert('Please select a category before saving.');
    }
  };

  return createPortal(
    <ModalBackdrop onClick={handleBackdropClick}>
      <ModalContainer>
        <CloseBtnWpar>
          <CloseBtn onClick={onClose} type="button">
            <ChevronDown size={22} color="#FF7601" />
          </CloseBtn>
        </CloseBtnWpar>
        <CategoriesWrap>
          {categoriesMore.map(({ id, categoryName }) => (
            <li key={id} style={{ listStyle: 'none' }}>
              <CategoryBtn onClick={() => handleClick(categoryName, id)}>
                {(() => {
                  const Icon = categoryIconMap[id] || CircleHelp;
                  return (
                    <Icon
                      size={20}
                      color="#FF7601"
                      stroke="#FF7601"
                      strokeWidth={2.25}
                      style={{
                        display: 'block',
                        margin: 0,
                      }}
                    />
                  );
                })()}
                <CategoryText text={categoryName} length={9} />
              </CategoryBtn>
            </li>
          ))}
        </CategoriesWrap>
        <BtnWrap>
          <StyledButton onClick={handleSaveClick} name="orange" type="submit">
            {t('madalGeneral.save')}
          </StyledButton>
          <StyledButton onClick={onClose} name="white" type="white">
            {t('madalGeneral.back')}
          </StyledButton>
        </BtnWrap>
      </ModalContainer>
    </ModalBackdrop>,
    modalRoot
  );
};
